module.exports = __webpack_public_path__ + "static/media/demo-6.03a168ad.jpg";